export function displaySystemSnackbar(bool,snackbarType="info",content="", autoHideDuration=null) {
    return {
        type: 'DISPLAY_SYSTEM_SNACKBAR',
        display: bool,
        snackbarType: snackbarType,
        content: content,
        autoHideDuration: autoHideDuration
    };
}